export default __webpack_public_path__ + "static/media/jquery.60fcb5dc.png";